<div class="container-fluid mt-3">
  <!-- ── Shared filters ──────────────────────────────────────────────────── -->
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-5">
      <mat-label>Centre(s)</mat-label>
      <mat-select [(ngModel)]="selectedCentreCodes" (selectionChange)="recompute()" multiple>
        <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">{{ c.centreName }}</mat-option>
      </mat-select>
      <mat-hint>Leave empty for all centres</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Date basis</mat-label>
      <mat-select [(ngModel)]="basisFilter" (selectionChange)="recompute()">
        <mat-option value="All">All</mat-option>
        <mat-option value="Exact">Exact only</mat-option>
        <mat-option value="Estimated">Estimated only</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="col-md-2 d-flex align-items-center">
      <button mat-mini-fab color="accent" (click)="clearSharedFilters()" matTooltip="Reset all filters">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

  <mat-tab-group animationDuration="0ms" class="mt-2">

    <!-- ══ Tab 1: detail list ═══════════════════════════════════════════════ -->
    <mat-tab label="Detail">
      <div class="card p-2 mt-2">
        <div class="row">
          <mat-form-field appearance="outline" class="col-md-5">
            <mat-label>Date of OM SHANTI — range</mat-label>
            <mat-date-range-input [rangePicker]="detailPicker">
              <input matStartDate [(ngModel)]="startDate" placeholder="Start date" (dateChange)="applyDetailFilters()">
              <input matEndDate [(ngModel)]="endDate" placeholder="End date" (dateChange)="applyDetailFilters()">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="detailPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #detailPicker></mat-date-range-picker>
          </mat-form-field>
          <div class="col-md-2 d-flex align-items-center">
            <button mat-mini-fab color="accent" (click)="clearDetailFilters()" matTooltip="Clear dates">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>

        <div class="ngxTableHeader">
          <ul class="header-buttons-left ms-0 mb-0">
            <li class="dropdown"><h2>Om Shanti Report</h2></li>
            <li class="dropdown m-l-20">
              <label for="search-input"><i class="material-icons search-icon">search</i></label>
              <input id="search-input" placeholder="Search" type="text" class="browser-default search-field"
                     (keyup)="applyTextFilter($event)" aria-label="Search box" #input>
            </li>
          </ul>
          <ul class="header-buttons mr-2">
            <li>
              <div class="export-button m-l-10" matTooltip="XLSX" (click)="downloadDetailReport()">
                <img src="assets/images/icons/xlsx.png" alt="Export"/>
              </div>
            </li>
          </ul>
        </div>

        <div class="summary-row">
          <span class="chip chip-total">Total: {{ totalCount }}</span>
          <span class="chip chip-exact">Exact date: {{ exactCount }}</span>
          <span class="chip chip-est">Estimated date: {{ estimatedCount }}</span>
        </div>

        <section class="example-container" tabindex="1">
          <table mat-table [dataSource]="dataSource" matSort id="om-shanti-table"
                 class="table table-striped table-bordered">

            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>#</th>
              <td mat-cell *matCellDef="let i = index">
                {{ paginator.pageIndex == 0 ? i + 1 : 1 + i + paginator.pageIndex * paginator.pageSize }}
              </td>
            </ng-container>

            <ng-container matColumnDef="childCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Code</th>
              <td mat-cell *matCellDef="let r">{{ r.childCode }}</td>
            </ng-container>

            <ng-container matColumnDef="childName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Child Name</th>
              <td mat-cell *matCellDef="let r">{{ r.childName }}</td>
            </ng-container>

            <ng-container matColumnDef="gender">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Gender</th>
              <td mat-cell *matCellDef="let r">{{ r.gender }}</td>
            </ng-container>

            <ng-container matColumnDef="centreName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Centre</th>
              <td mat-cell *matCellDef="let r">{{ r.centreName || r.centreCode }}</td>
            </ng-container>

            <ng-container matColumnDef="dateOfOmShanti">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of OM SHANTI</th>
              <td mat-cell *matCellDef="let r">{{ display(r.dateOfOmShanti) || '—' }}</td>
            </ng-container>

            <ng-container matColumnDef="dateBasis">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Basis</th>
              <td mat-cell *matCellDef="let r">
                <span class="badge"
                      [class.badge-exact]="r.dateBasis === 'Exact'"
                      [class.badge-est]="r.dateBasis !== 'Exact' && r.dateBasis !== 'Unknown'"
                      [class.badge-unknown]="r.dateBasis === 'Unknown'">
                  {{ r.dateBasis }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="modeOmShanti">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Mode of Confirmation</th>
              <td mat-cell *matCellDef="let r">{{ r.modeOmShanti }}</td>
            </ng-container>

            <ng-container matColumnDef="requestStatus">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Request Status</th>
              <td mat-cell *matCellDef="let r">{{ r.requestStatus | titlecase }}</td>
            </ng-container>

            <ng-container matColumnDef="remark">
              <th mat-header-cell *matHeaderCellDef>Remark</th>
              <td mat-cell *matCellDef="let r">{{ r.remark }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                {{ isLoading ? 'Loading…' : 'No OM SHANTI records match the current filters' }}
              </td>
            </tr>
          </table>
        </section>

        <mat-paginator [pageSizeOptions]="[25, 50, 100, 200, 500]" aria-label="Select page"></mat-paginator>
      </div>
    </mat-tab>

    <!-- ══ Tab 2: count by centre × year ═══════════════════════════════════ -->
    <mat-tab label="Count by Year">
      <div class="card p-2 mt-2">
        <div class="row">
          <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>From year</mat-label>
            <mat-select [(ngModel)]="fromYear" (selectionChange)="buildYearTable()">
              <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="col-md-2">
            <mat-label>To year</mat-label>
            <mat-select [(ngModel)]="toYear" (selectionChange)="buildYearTable()">
              <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="col-md-4 d-flex align-items-center">
            <mat-checkbox [(ngModel)]="includeUnknown" (change)="buildYearTable()">Include undated</mat-checkbox>
            <button mat-mini-fab color="accent" (click)="clearYearFilters()" matTooltip="Reset years" class="ms-2">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="col-md-4 d-flex align-items-center justify-content-end">
            <div class="export-button" matTooltip="XLSX" (click)="downloadYearReport()">
              <img src="assets/images/icons/xlsx.png" alt="Export"/>
            </div>
          </div>
        </div>

        <div class="summary-row">
          <span class="chip chip-total">Grand total: {{ grandTotal }}</span>
          <span class="chip chip-year" *ngFor="let y of years">{{ y }}: {{ yearTotals[y] }}</span>
          <span class="chip chip-unknown" *ngIf="showUnknownColumn">Undated: {{ unknownTotal }}</span>
        </div>

        <div class="table-scroll">
          <table id="om-shanti-year-table" class="table table-striped table-bordered count-table">
            <thead>
              <tr>
                <th>Centre</th>
                <th class="num" *ngFor="let y of years">{{ y }}</th>
                <th class="num" *ngIf="showUnknownColumn">Undated</th>
                <th class="num">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of yearRows">
                <td>{{ row.centreName }}</td>
                <td class="num" *ngFor="let y of years">{{ row.perYear[y] || 0 }}</td>
                <td class="num" *ngIf="showUnknownColumn">{{ row.unknown }}</td>
                <td class="num total-cell">{{ row.total }}</td>
              </tr>
              <tr *ngIf="!yearRows.length && !isLoading">
                <td [attr.colspan]="years.length + (showUnknownColumn ? 3 : 2)">
                  No OM SHANTI records for the selected filters
                </td>
              </tr>
            </tbody>
            <tfoot *ngIf="yearRows.length">
              <tr class="total-row">
                <td>TOTAL</td>
                <td class="num" *ngFor="let y of years">{{ yearTotals[y] }}</td>
                <td class="num" *ngIf="showUnknownColumn">{{ unknownTotal }}</td>
                <td class="num">{{ grandTotal }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </mat-tab>

    <!-- ══ Tab 3: count by centre for a date range ════════════════════════ -->
    <mat-tab label="Count by Date Range">
      <div class="card p-2 mt-2">
        <div class="row">
          <mat-form-field appearance="outline" class="col-md-5">
            <mat-label>Date of OM SHANTI — range</mat-label>
            <mat-date-range-input [rangePicker]="rangePicker">
              <input matStartDate [(ngModel)]="rangeStart" placeholder="Start date" (dateChange)="buildRangeTable()">
              <input matEndDate [(ngModel)]="rangeEnd" placeholder="End date" (dateChange)="buildRangeTable()">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY · empty = all dates</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="rangePicker"></mat-datepicker-toggle>
            <mat-date-range-picker #rangePicker></mat-date-range-picker>
          </mat-form-field>

          <div class="col-md-2 d-flex align-items-center">
            <button mat-mini-fab color="accent" (click)="clearRange()" matTooltip="Clear range">
              <mat-icon>clear</mat-icon>
            </button>
          </div>

          <div class="col-md-5 d-flex align-items-center justify-content-end">
            <div class="export-button" matTooltip="XLSX" (click)="downloadRangeReport()">
              <img src="assets/images/icons/xlsx.png" alt="Export"/>
            </div>
          </div>
        </div>

        <div class="summary-row">
          <span class="chip chip-total">Total in range: {{ rangeTotal }}</span>
          <span class="chip chip-unknown" *ngIf="rangeExcludesUndated">
            Undated (excluded): {{ rangeExcludesUndated }}
          </span>
        </div>

        <div class="table-scroll">
          <table id="om-shanti-range-table" class="table table-striped table-bordered count-table">
            <thead>
              <tr>
                <th>Centre</th>
                <th class="num">OM SHANTI count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of rangeRows">
                <td>{{ row.centreName }}</td>
                <td class="num">{{ row.count }}</td>
              </tr>
              <tr *ngIf="!rangeRows.length && !isLoading">
                <td colspan="2">No OM SHANTI records in the selected date range</td>
              </tr>
            </tbody>
            <tfoot *ngIf="rangeRows.length">
              <tr class="total-row">
                <td>TOTAL</td>
                <td class="num">{{ rangeTotal }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>
